import React, { useState, useEffect } from "react";
//mport Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import logo from "./AJAY.jpeg"; // with import
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function ModalWrapper(prop) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    handleShow(prop.showModal);
  }, [prop]);

  const handleClose = () => setShow(false);
  const handleShow = (val) => setShow(val);
  return (
    <Modal show={show} fade={false} onHide={handleClose} animation={true}>
      <Modal.Header closeButton>
        {prop.dataOnModal.wifeName ? (
          ""
        ) : (
          <Modal.Title>
            {prop.dataOnModal.name +
              " " +
              prop.dataOnModal.nickName +
              " चतुर्वेदी"}
          </Modal.Title>
        )}
      </Modal.Header>
      <div class="modal-content">
        <Modal.Body>
          {prop.dataOnModal.wifeName ? (
            <div class="container">
              <div class="card-group w-100">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-column align-items-center text-center">
                      <img
                        src={logo}
                        alt="Admin"
                        class="rounded-circle"
                        width="150"
                      />
                      <div class="mt-3">
                        <h4>
                          {prop.dataOnModal.name +
                            " " +
                            prop.dataOnModal.nickName}
                          {" चतुर्वेदी"}
                        </h4>
                        <p class="text-secondary mb-1">
                          {prop.dataOnModal.workProfile}
                        </p>
                        <p class="text-secondary mb-1">
                          {prop.dataOnModal.companyName}
                        </p>
                        <p class="text-muted font-size-sm">
                          {prop.dataOnModal.address}
                        </p>
                        {/* <button class="btn btn-primary">Follow</button>
                        <button class="btn btn-outline-primary">Message</button> */}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Wife's Name</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.wifeName + " चतुर्वेदी"}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Address</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.address}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Work Profile</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.workProfile}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Designation</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.designation}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Company</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.companyName}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Work Location</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.workLocation}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <h6 class="mb-0">Mobile</h6>
                      </div>
                      <div class="col-sm-8 text-secondary">
                        {prop.dataOnModal.mobile}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex flex-column align-items-center text-center">
                      <Carousel>
                        <div>
                          <img src={logo} />
                          <p className="legend">Legend 1</p>
                        </div>
                        <div>
                          <img src={logo} />
                          <p className="legend">Legend 2</p>
                        </div>
                      </Carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            "Not much detail available."
          )}
        </Modal.Body>
      </div>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
/*
<img src={logo} class="card-img" alt="..." />

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Save Changes
        </Button>
        
        
        
        <div
                    id="carousel-modal-demo"
                    class="carousel slide"
                    data-ride="carousel"
                  >
                    <div class="carousel-inner">
                      <div class="item">
                        <img src={logo} alt="banana" />
                      </div>
                      <div class="item">
                        <img src={logo} alt="currant" />
                      </div>
                      <div class="item">
                        <img src={logo} alt="mango" />
                      </div>
                      <div class="item active">
                        <img src={logo} alt="strawberries" />
                      </div>
                    </div>

                    <a
                      class="left carousel-control"
                      href="#carousel-modal-demo"
                      data-slide="prev"
                    >
                      <span class="glyphicon glyphicon-chevron-left"></span>
                    </a>
                    <a
                      class="right carousel-control"
                      href="#carousel-modal-demo"
                      data-slide="next"
                    >
                      <span class="glyphicon glyphicon-chevron-right"></span>
                    </a>
                  </div>
        */
